import React, { useState, useContext, useEffect } from 'react';
import { useFormikContext } from 'formik';

import { ResponsiveContext, EtapesSaisieContext } from '../../App';
import { Simulation } from '../../types/main';
import { creeClassNamesZoneSaisie } from '../../utils/utils';
import { SaisieContext } from '../formConteneur';
import { MySelect } from '../champsSaisieAffichage/mySelect';
import { MyListeBoutons } from '../champsSaisieAffichage/myListeBoutons';
import { MyTextInput } from '../champsSaisieAffichage/myTextInput';
// import { VoirDetail } from '../boutons/generaux/voirDetail';

export const SaisieNombreOptions: React.FC = () => {
  const { setBoutonSuivant } = useContext(SaisieContext);
  const { dimensions } = useContext(ResponsiveContext);
  const classNamesZoneSaisie = creeClassNamesZoneSaisie(dimensions.largeur, 4);

  useEffect(() => {
    setBoutonSuivant('non');
  }, [])

  return (
    <div
      className={classNamesZoneSaisie.join(' ')}
      // style={styleZoneSaisie}
    >
      <div className="col1">
        <div className="col">
            <h1 className="titre">Options</h1>
            <h2 className="titre">Combien avez-vous d'options ?</h2>
          <div className="group" style={{ display: "flex" }}>
            <MyListeBoutons
              label="nombre_options"
              // labelAvecRC={<><u>F</u>ilière</>}
              // toucheRC={['f', 'F']}
              name="nb_options"
              required
              autoFocus={true}
              boutons={['Aucune', '1', '2']}
              toucheRC={['0', 'Escape', 'Enter', '1', '2']}
              matchTouchesElement={[0, 0, 0, 1, 2]}
              // boutons={['S', 'ES', 'L', 'STMG']}
              classes={['boutonSize1']}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
